import React from 'react';
import usePage from '@dashboard/hooks/usePage';
import { Form } from '@dashboard/components/Formik';

const FilesForm = () => {
  const { page, updatePage } = usePage();

  return (
    <Form
      autosave
      showState={false}
      initialValues={{
        enableFileAccessForInactiveSubscriptions: page?.enableFileAccessForInactiveSubscriptions,
      }}
      onSubmit={async values => {
        const { data, error } = await updatePage.mutateAsync(values);

        return {
          data,
          error,
        };
      }}
      fields={[
        {
          name: 'enableFileAccessForInactiveSubscriptions',
          label: 'Enable access to files for inactive subscriptions',
          type: 'toggle',
        },
      ]}
    />
  );
};

export default FilesForm;
